import { z } from 'zod';

// Любой API-эндпоинт: опиши тут zod-схему ответа, выведи тип через z.infer,
// и используй ОДНУ и ТУ ЖЕ схему на сервере (валидация ответа) и на клиенте
// (валидация полученного JSON). Так клиент и сервер не разойдутся в контракте.

export const HelloResponseSchema = z.object({
  message: z.string(),
  timestamp: z.string().datetime(),
});
export type HelloResponse = z.infer<typeof HelloResponseSchema>;

// --- Notes ---

export const NoteSchema = z.object({
  id: z.number().int().positive(),
  title: z.string(),
  content: z.string(),
  createdAt: z.string(),
});
export type Note = z.infer<typeof NoteSchema>;

export const NotesResponseSchema = z.array(NoteSchema);

export const CreateNoteInputSchema = z.object({
  title: z.string().min(1).max(200),
  content: z.string().max(10_000).optional(),
});
export type CreateNoteInput = z.infer<typeof CreateNoteInputSchema>;

// --- Products ---

export const ProductSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  price: z.number().positive(),
  originalPrice: z.number().nullable(),
  category: z.string(),
  image: z.string(),
  description: z.string(),
  badge: z.string().nullable(),
});
export type Product = z.infer<typeof ProductSchema>;

export const ProductsResponseSchema = z.array(ProductSchema);

export const ProductInputSchema = z.object({
  name: z.string().min(1).max(200),
  price: z.number().positive(),
  originalPrice: z.number().positive().nullable().optional(),
  category: z.string().min(1).max(100),
  image: z.string().min(1).max(10),
  description: z.string().max(500),
  badge: z.string().max(50).nullable().optional(),
});
export type ProductInput = z.infer<typeof ProductInputSchema>;
